(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellow-home"] && !Shopify.designMode) return;
  try {
    

class MellowHome extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;
    this.abort = new AbortController();
    const track = this.querySelector('[data-home-carousel]');
    if (!track) return;
    const move = direction => {
      const card = track.querySelector('.mellow-home__perspective');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduced ? 'instant' : 'smooth' });
    };
    this.querySelector('[data-home-previous]')?.addEventListener('click', () => move(-1), { signal: this.abort.signal });
    this.querySelector('[data-home-next]')?.addEventListener('click', () => move(1), { signal: this.abort.signal });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.initialised = false; }
}
if (!customElements.get('mellow-home')) customElements.define('mellow-home', MellowHome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellow-saffron-pdp"] && !Shopify.designMode) return;
  try {
    
class MellowSaffronPdp extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.galleryItems=[...this.querySelectorAll('[data-gallery-src]')];this.galleryIndex=0;this.showGallery(0);const galleryStage=this.querySelector('.ms-gallery__stage');
  this.galleryTrack=this.querySelector('[data-gallery-track]');
  this.galleryTrack?.addEventListener('scroll',()=>{this.querySelectorAll('img[data-gallery-lazy-src]').forEach(img=>{img.removeAttribute('loading');img.src=img.dataset.galleryLazySrc;img.removeAttribute('data-gallery-lazy-src');});const slides=[...this.galleryTrack.children];const step=slides[1]?slides[1].offsetLeft-slides[0].offsetLeft:1;const index=Math.min(slides.length-1,Math.round(this.galleryTrack.scrollLeft/step));if(index!==this.galleryIndex){this.galleryIndex=index;this.querySelector('[data-gallery-count]').textContent=`${index+1} / ${slides.length}`;}},{passive:true});
  galleryStage?.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.showGallery(this.galleryIndex+(event.key==='ArrowRight'?1:-1));}});
  galleryStage?.addEventListener('pointerdown',event=>{if(window.matchMedia('(max-width:749px)').matches||event.target.closest('button'))return;this.galleryStart={x:event.clientX,y:event.clientY};});galleryStage?.addEventListener('pointerup',event=>{if(!this.galleryStart)return;const dx=event.clientX-this.galleryStart.x,dy=event.clientY-this.galleryStart.y;this.galleryStart=null;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))this.showGallery(this.galleryIndex+(dx<0?1:-1));});
  // The shared magnesium buybox owns purchase events and selling plans.
  this.addEventListener('click',(event)=>{
   const thumb=event.target.closest('[data-gallery-src]');
   if(thumb)this.showGallery(this.galleryItems.indexOf(thumb));const galleryArrow=event.target.closest('[data-gallery-step]');if(galleryArrow)this.showGallery(this.galleryIndex+Number(galleryArrow.dataset.galleryStep));
   const arrow=event.target.closest('button[aria-label="Previous slide"],button[aria-label="Next slide"]');
   if(arrow){const section=arrow.closest('.shopify-section');const track=section?.querySelector('.swiper,.saphire-science__viewport');if(track){const backwards=arrow.getAttribute('aria-label')==='Previous slide';track.scrollBy({left:(backwards?-1:1)*track.clientWidth*.8,behavior:'smooth'});for(const button of section.querySelectorAll('button[aria-label="Previous slide"]'))button.disabled=false;}}
   const dot=event.target.closest('.saphire-science__dot');if(dot){const section=dot.closest('.shopify-section');const viewport=section.querySelector('.saphire-science__viewport');const slide=section.querySelector('.saphire-science__slide');const index=Number(dot.getAttribute('aria-label').split(' ')[1])-1;viewport.scrollTo({left:index*(slide.getBoundingClientRect().width+18),behavior:'smooth'});for(const button of section.querySelectorAll('.saphire-science__dot'))button.classList.toggle('is-active',button===dot);}
   const reviewArrow=event.target.closest('.sap-prev,.sap-next');
   if(reviewArrow){const reviews=[...this.querySelectorAll('.sap-review')];let index=reviews.findIndex(r=>getComputedStyle(r).display!=='none');index=(index+(reviewArrow.classList.contains('sap-prev')?-1:1)+reviews.length)%reviews.length;for(let i=0;i<reviews.length;i++)reviews[i].style.display=i===index?'flex':'none';for(const button of this.querySelectorAll('.sap-prev'))button.disabled=false;}
  });

  this.storyTrack=this.querySelector('[data-mood-stories]');
  this.uiAbort=new AbortController();
  this.initIngredientsDisclosure();
  this.initPageMotion();
  this.storyTrack?.addEventListener('scroll',()=>this.updateStoryControls(),{passive:true,signal:this.uiAbort.signal});
  this.addEventListener('click',event=>{const control=event.target.closest('[data-mood-step]');if(!control||!this.storyTrack)return;const cards=[...this.storyTrack.children];const step=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:this.storyTrack.clientWidth;this.storyTrack.scrollBy({left:Number(control.dataset.moodStep)*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});},{signal:this.uiAbort.signal});
  this.storyResize=new ResizeObserver(()=>this.updateStoryControls());if(this.storyTrack)this.storyResize.observe(this.storyTrack);this.updateStoryControls();
  const clock=this.querySelector('[data-sale-clock]');const ends=Date.now()+17*3600*1000;
  const tick=()=>{const remaining=Math.max(0,Math.floor((ends-Date.now())/1000));const h=Math.floor(remaining/3600),m=Math.floor(remaining%3600/60),s=remaining%60;if(clock)clock.textContent=`${h}h : ${String(m).padStart(2,'0')}m : ${String(s).padStart(2,'0')}s`;};tick();this.timer=setInterval(tick,1000);
 }
 showGallery(index){this.querySelectorAll('img[data-gallery-lazy-src]').forEach(img=>{img.removeAttribute('loading');img.src=img.dataset.galleryLazySrc;img.removeAttribute('data-gallery-lazy-src');});if(!this.galleryItems.length)return;this.galleryIndex=(index+this.galleryItems.length)%this.galleryItems.length;const current=this.galleryItems[this.galleryIndex];this.querySelector('[data-main-image]').src=current.dataset.gallerySrc;this.querySelector('[data-main-image]').alt=current.querySelector('img')?.alt||'';for(const button of this.galleryItems)button.setAttribute('aria-pressed',String(button===current));const count=this.querySelector('[data-gallery-count]');if(count)count.textContent=`${this.galleryIndex+1} / ${this.galleryItems.length}`;const desktopCount=this.querySelector('[data-gallery-desktop-count]');if(desktopCount)desktopCount.textContent=`${this.galleryIndex+1} / ${this.galleryItems.length}`;if(window.matchMedia('(min-width:750px)').matches){const thumbs=current.parentElement;const offset=current.getBoundingClientRect().left-thumbs.getBoundingClientRect().left;thumbs.scrollTo({left:thumbs.scrollLeft+offset-(thumbs.clientWidth-current.clientWidth)/2,behavior:'auto'});}if(this.ready&&this.galleryHasShown&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){const image=this.querySelector('[data-main-image]');this.galleryAnimation?.cancel();this.galleryAnimation=image?.animate([{opacity:.55,transform:'scale(.985)'},{opacity:1,transform:'scale(1)'}],{duration:260,easing:'cubic-bezier(.22,1,.36,1)'});}if(this.galleryTrack&&window.matchMedia('(max-width:749px)').matches){const slides=[...this.galleryTrack.children];const step=slides[1]?slides[1].offsetLeft-slides[0].offsetLeft:0;this.galleryTrack.scrollTo({left:this.galleryIndex*step,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}this.galleryHasShown=true;}

 initIngredientsDisclosure(){
  this.ingredientDisclosure=this.querySelector('[data-ingredients-disclosure]');
  this.ingredientPanel=this.querySelector('[data-ingredients-panel]');
  if(!this.ingredientDisclosure||!this.ingredientPanel)return;
  this.ingredientDisclosure.querySelector('summary').addEventListener('click',event=>{
   event.preventDefault();
   this.setIngredientsOpen(!(this.ingredientTargetOpen??this.ingredientDisclosure.open));
  },{signal:this.uiAbort.signal});
  this.addEventListener('click',event=>{
   const link=event.target.closest('a[href="#mm-ingredients"]');
   if(!link)return;
   event.preventDefault();
   this.setIngredientsOpen(true).then(()=>{
    if(!this.isConnected)return;
    this.querySelector('#mm-ingredients')?.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   });
  },{signal:this.uiAbort.signal});
  if(window.location.hash==='#mm-ingredients')this.ingredientDisclosure.open=true;
 }
 async setIngredientsOpen(open){
  const disclosure=this.ingredientDisclosure,panel=this.ingredientPanel;
  if(!disclosure||!panel)return;
  if(!this.ingredientAnimation&&disclosure.open===open){this.ingredientTargetOpen=open;return;}
  this.ingredientTargetOpen=open;
  const startHeight=disclosure.open?panel.getBoundingClientRect().height:0;
  this.ingredientAnimation?.cancel();
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!panel.animate){
   disclosure.open=open;panel.style.height='';panel.style.overflow='';return;
  }
  disclosure.open=true;
  panel.style.overflow='hidden';
  const animation=panel.animate([{height:startHeight+'px',opacity:open?0:1},{height:(open?panel.scrollHeight:0)+'px',opacity:open?1:0}],{duration:400,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
  this.ingredientAnimation=animation;
  try{await animation.finished;}catch{return;}
  if(this.ingredientAnimation!==animation)return;
  disclosure.open=open;
  animation.cancel();this.ingredientAnimation=null;
  panel.style.height='';panel.style.overflow='';
 }
 initPageMotion(){
  this.motionAnimations=new Set();
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(preference.matches||!window.IntersectionObserver||!Element.prototype.animate)return;
  const selectors='.mood-section__heading,.mood-split__copy,.mood-split__photo,.mood-feature,.mood-research,.mood-timeline__step,.mood-perspective,.mood-faq,.ms-comparison__card,.ms-gallery__stage,.ms-rating,.ms-title,.mm-audit__lead,.ms-benefits,.mellow-offer,.ms-guarantee';
  const targets=[...this.querySelectorAll(selectors)];
  const reveal=element=>{
   element.dataset.motionState='revealed';
   if(preference.matches)return;
   const siblings=[...element.parentElement.children].filter(node=>node.dataset.motionState);
   const delay=Math.min(Math.max(0,siblings.indexOf(element))*55,165);
   const animation=element.animate([{opacity:0,transform:'translateY(20px)'},{opacity:1,transform:'translateY(0)'}],{id:'mellow-reveal',duration:600,delay,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
   this.motionAnimations.add(animation);
   animation.onfinish=()=>{this.motionAnimations.delete(animation);animation.cancel();};
  };
  this.motionObserver=new IntersectionObserver(entries=>{
   for(const entry of entries){
    if(!entry.isIntersecting)continue;
    reveal(entry.target);this.motionObserver.unobserve(entry.target);
   }
  },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
  for(const target of targets){target.dataset.motionState='pending';this.motionObserver.observe(target);}
  preference.addEventListener('change',event=>{
   if(!event.matches)return;
   this.motionObserver?.disconnect();
   for(const animation of this.motionAnimations)animation.cancel();
   this.motionAnimations.clear();
   for(const target of targets)target.dataset.motionState='revealed';
   if(this.ingredientAnimation){const open=this.ingredientTargetOpen;this.ingredientAnimation.cancel();this.ingredientAnimation=null;this.ingredientDisclosure.open=open;this.ingredientPanel.style.overflow='';}
  },{signal:this.uiAbort.signal});
 }

 disconnectedCallback(){clearInterval(this.timer);this.uiAbort?.abort();this.storyResize?.disconnect();this.motionObserver?.disconnect();this.ingredientAnimation?.cancel();this.galleryAnimation?.cancel();for(const animation of this.motionAnimations||[])animation.cancel();}
 updateStoryControls(){if(!this.storyTrack)return;const cards=[...this.storyTrack.children];if(!cards.length)return;const distance=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:this.storyTrack.clientWidth;const index=Math.max(0,Math.min(cards.length-1,Math.round(this.storyTrack.scrollLeft/distance)));const status=this.querySelector('[data-mood-status]');if(status)status.textContent=`${index+1} / ${cards.length}`;const previous=this.querySelector('[data-mood-step="-1"]'),next=this.querySelector('[data-mood-step="1"]');if(previous)previous.disabled=this.storyTrack.scrollLeft<2;if(next)next.disabled=this.storyTrack.scrollLeft+this.storyTrack.clientWidth>=this.storyTrack.scrollWidth-2;}
 money(cents){return new Intl.NumberFormat('en-GB',{style:'currency',currency:this.dataset.currency||'GBP'}).format(Number(cents)/100);}
 updatePrice(){
  const recurring=Boolean(this.subscription?.checked);
  for(const radio of this.radios){const price=recurring&&radio.dataset.planId?Number(radio.dataset.planPrice):Number(radio.dataset.regularPrice);const label=radio.closest('.ms-pack');label.querySelector('[data-pack-price]').textContent=this.money(price);const per=label.querySelector('[data-per-pack]');if(per)per.textContent=`${this.money(price/Number(radio.dataset.packCount))} Per Pack`;}
  const selected=this.radios.find(r=>r.checked);if(!selected)return;
  for(const gifts of this.querySelectorAll('[data-gifts-for]'))gifts.hidden=gifts.dataset.giftsFor!==selected.value;const giftPanel=this.querySelector('[data-selected-gifts]');if(giftPanel)giftPanel.hidden=Number(selected.dataset.packCount)===1;
  const plan=this.querySelector('[data-selling-plan]');if(plan){plan.value=selected.dataset.planId||'';plan.disabled=!recurring||!selected.dataset.planId;}
  const savings=this.querySelector('[data-save-percentage]');if(savings){const regular=Number(selected.dataset.regularPrice),discounted=Number(selected.dataset.planPrice);savings.textContent=`${Math.round((regular-discounted)/regular*100)}%`;}
 }
 async addToCart(event){
  event.preventDefault();const button=this.form.querySelector('[name="add"]');const error=this.querySelector('[data-cart-error]');button.disabled=true;error.hidden=true;
  try{const data=new FormData(this.form);data.delete('pack_choice');const url=new URL((window.Shopify?.routes?.root||'/')+'cart/add.js',window.location.origin);const response=await fetch(url,{method:'POST',body:data,headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'Unable to add this item. Please try again.');window.location.assign((window.Shopify?.routes?.root||'/')+'cart');}
  catch(failure){error.textContent=failure.message;error.hidden=false;button.disabled=false;}
 }
}
if(!customElements.get('mellow-saffron-pdp'))customElements.define('mellow-saffron-pdp',MellowSaffronPdp);


if (!customElements.get('mellow-ingredient-carousel')) {
 customElements.define('mellow-ingredient-carousel',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort=new AbortController();
   const signal=this.abort.signal,track=this.querySelector('.mellow-ingredient-carousel__track');
   const prev=this.querySelector('[data-ingredient-prev]'),next=this.querySelector('[data-ingredient-next]');
   if(!track||!prev||!next)return;
   const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
   const move=direction=>{const card=track.querySelector('.mellow-ingredient-card');if(!card)return;track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
   prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});
   track.addEventListener('scroll',update,{signal,passive:true});
   this.observer=new ResizeObserver(update);this.observer.observe(track);
   this.classList.add('is-enhanced');update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 });
}


  } catch(e) { console.error(e); }
})();
})();
